import React, { useEffect } from 'react';
import FullPageCarousel from '../Components/Carousel/FullPageCarousel';
import ImageCard from '../Components/ImageCard/ImageCard';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './PageCss/HomePage.css';
import SectionHeader from '../Components/SectionHeader/SectionHeader';
import { useMediaQuery } from 'react-responsive'; // Import useMediaQuery hook
import Promoter from '../Components/Promoter/Promoter';
import FeatureCardCarousel from '../Components/FeaturesCardCarousal/FeatureCardCarousal'
import AOS from 'aos';
import 'aos/dist/aos.css';
import NumberGrid from '../Components/NumberGrid/NumberGrid';
import { useTranslation } from 'react-i18next';
import imgmark from '../assets/mark.png'

// import qualitySticker from '../assets/QualityLogo.png';
// import glob from '../assets/GlobLogo.png';
// import hose from '../assets/HoseLogo.png';
// import isoLogo from '../assets/ISO-Logo.png';
import imgCarton from '../assets/Hansa-Flex_Kartons_Shop.png';
import imgMobileService from '../assets/mobile-hydraulic-service.jpg';
import ingIndustries_fr from '../assets/WesiteCoverImage.jpg';
import ingIndustries_en from '../assets/WesiteCoverImage.jpg';
import imgHydraulicTraining from '../assets/Services/HydraulicAcademy/InHouseSeminars.jpg'
import imgManagementOfAssemblyHose from '../assets/home2.jpg'
import Horizontal from '../Components/Horizontal/Horizontal';

// import imgLocal from '../assets/news-events/Local.png';
// import imgMeasurement from '../assets/news-events/Measurement.png';
// import imgLessHeadache from '../assets/news-events/LessHeadache.png';


function HomePage() {
  const { i18n, t } = useTranslation();
  var ingIndustries = ingIndustries_fr;
  if (i18n.language === 'en') {
    ingIndustries = ingIndustries_en;
  }

  const isLaptop = useMediaQuery({ minWidth: 1024 }); // Define the breakpoint for laptop screen size
  const isMobile = window.innerWidth <= 768;


  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on component mount
  }, []);


  useEffect(() => {
    AOS.init({
      // Global settings:
      disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
      startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
      initClassName: 'aos-init', // class applied after initialization
      animatedClassName: 'aos-animate', // class applied on animation
      useClassNames: false, // if true, will add content of `data-aos` as classes on scroll

      // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
      offset: 320, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 300, // values from 0 to 3000, with step 50ms
      easing: 'ease', // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
    });
  }, []);

  const featuresData = [
    {
      title: "High quality",
      description: "We are a certified company and we work with materials with the highest quality standards.",
      image: imgmark
    },
    {
      title: "X-CODE",
      description: "Have your hydraulic hoses assembled and monitored and reduce downtime of your machines.",
      image: imgmark
    },
    {
      title: "Flexible Service Teams",
      description: "Our assembly and design teams are always ready to serve you with a fully equipped mobile hydraulic workshop.",
      image: imgmark
    },
    {
      title: "All in one place",
      description: "Benefit from the complete range of hoses and hydraulic components from HANSA-FLEX.",
      image: imgmark
    },

    // Add more objects for additional FeaturesCard data
  ];

  //promoter content

  const promoterTitle = 'PLACE YOUR ORDER TODAY!';
  const promoterChecklistItems = [
    'The full HANSA-FLEX product range with more than 80,000 articles',
    'Category-specific filter parameters enable quick navigation',
    'Current availability shown in real-time for better planning certainty'
  ];
  const promoterButtonLabels = ['CONTACT US', 'FIND OUT MORE !'];

  //hall of fame
  const numbers = ['30,000+', '40,000+', '40,976'];
  const subtitles = ['Available parts in Brazil', 'Hoses built yearly in Brazil', 'X-CODES recorded in Brazil'];

  const googleReviewsLink = "https://www.google.com/search?q=hansa-flex+Brazil&sca_esv=08810a66cef76e77&rlz=1C1GCEU_enIN1077IN1077&sxsrf=ADLYWIKxhdGF-GkH6-ThKwzH2DPyaiyFqg%3A1735805381336&ei=xUl2Z6WSFMW10-kP2qKXMA&ved=0ahUKEwjliJ35ytaKAxXF2jQHHVrRBQYQ4dUDCBA&uact=5&oq=hansa-flex+Brazil&gs_lp=Egxnd3Mtd2l6LXNlcnAiEWhhbnNhLWZsZXggYnJhemlsMgQQIxgnMgYQABgWGB4yBhAAGBYYHjIIEAAYgAQYogQyCBAAGIAEGKIEMggQABiABBiiBDIIEAAYgAQYogRIyTBQuwpY9SxwA3gAkAEAmAHOAaABxhWqAQYwLjE1LjK4AQPIAQD4AQGYAhSgAsAWwgILEAAYgAQYsAMYogTCAgsQABiABBiRAhiKBcICChAAGIAEGEMYigXCAg4QABiABBixAxiDARiKBcICERAuGIAEGLEDGNEDGIMBGMcBwgILEC4YgAQYsQMY1ALCAggQABiABBixA8ICCBAuGIAEGLEDwgILEAAYgAQYsQMYgwHCAgsQLhiABBixAxiDAcICBRAAGIAEwgILEC4YgAQYxwEYrwHCAgUQLhiABJgDAIgGAZAGBJIHBjMuMTUuMqAHqskB&sclient=gws-wiz-serp#lrd=0x157717b000a80d3:0x9f301e860b524da4,1,,,,";


  return (
    <div>
      <FullPageCarousel />

      <div>
        <SectionHeader
          title="Our services"
        />

        <Container className="custom-container">
          <Row>
            {/* <Col sm={12} md={6} lg={8} >
              <ImageCard image={imgHose} learnMoreLink="/hydraulic-hoses" title="Custom Hydraulic Hoses" desc="Our custom hydraulic hoses are meticulously crafted to your specifications, ensuring peak performance and durability. Track each hose effortlessly with our innovative X-Code Manager system, simplifying inventory management. Simplify ordering with Easy-Order Scan and optimize your workflow with our comprehensive kitting solutions." />
            </Col> */}
            <Col sm={12} md={6} lg={4} >
              <ImageCard image={imgManagementOfAssemblyHose} learnMoreLink="/preventative-maintainance" title="Management of Assembled Hoses" desc="Preventative maintenance of hydraulic systems and machines can be very easy – with the X-CODE Manager portal. By linking our X-CODE in the app, you can view all installed hydraulic hoses online and keep their data up to date. Specify maintenance and inspection intervals, schedule service appointments and carry out visual inspections in accordance with standards." />
            </Col>
            <Col sm={12} md={6} lg={4} >
              <ImageCard image={imgMobileService} learnMoreLink="/mobile-rapid-hydraulic-service" title="MHS - Mobile Hydraulic Service" desc="When hydraulic components fail unexpectedly, you need to act quickly. With 200 vehicles throughout Germany and 6 in Brazil, our Mobile Hydraulic Service (MHS) is always there for you to minimise your downtimes. Our well-trained and experienced service technicians are with you within an hour. They correct defects, install replacement parts and manufacture custom hoses on site in their on-board workshop." />
            </Col>
            <Col sm={12} md={6} lg={4} >
              <ImageCard image={imgHydraulicTraining} learnMoreLink="/hydraulic-academy" title="The Hydraulics Academy" desc="HANSA-FLEX offers training courses and continuing education in all aspects of fluid and pipeline technology, as well as training programs for hydraulic specialists, which are carried out by the International Hydraulic Academy (IHA) in Dresden (Germany)." />
            </Col>
            {/* <Col sm={12} md={6} lg={4} >
              <ImageCard image={imgXcodeManagement} learnMoreLink="https://my.hansa-flex.com.br/pt_BR/login" title="X-CODE Manager" desc="Harness the power of X-Code Manager to effortlessly track and manage your hydraulic hose inventory. Each hose is assigned a unique X-Code, providing real-time visibility and control. Say goodbye to inventory headaches and hello to streamlined operations with our cutting-edge inventory management solutions." />
            </Col> */}

          </Row>
        </Container>

      </div>

      {/* <div>
        <SectionHeader
          title="Explore our units!"
          paragraph="We have our units in Pune, which provide extensive range of products!"
        />
        <ShowcaseCarousel carouselItems={carouselItems} descDisplay={isMobile ? 'none' : 'block'} />
      </div>
      <br /><br /><br /> */}

      <div className='div-gray center-all-items'>
        <SectionHeader
          title="Advantages OF HANSA-FLEX"
          subtitle=""
        />
        <FeatureCardCarousel featuresData={featuresData} />
      </div>


      <div>
        {/* {isLaptop && ( */}
        <Promoter
          title={promoterTitle}
          checklistItems={promoterChecklistItems}
          btnLabel1={"Find Out More !"}
          btnLabel1Link={"https://shop.hansa-flex.com.br/pt_BR/"}
          imageUrl={imgCarton}
        />
        {/* // TODO: contact us button */}
        {/* )} */}
      </div>

      {/* <div>
        <SectionHeader
          title="News" />
        <Container className="custom-container">
          <Row>
            <Col sm={12} md={6} lg={4} data-aos="fade-up"><ImageCard image={imgOperatorProtection} learnMoreLink={'/iree'} title="Operator protection – the right way!" desc={"Operator protection – the right way! From implementing stricter industrial health and safety regulations."} /></Col>
            <Col sm={12} md={6} lg={4} data-aos="fade-up"><ImageCard image={imgOperatorProtection} learnMoreLink={'/product-training'} title="Size Matters: Calculating the Diameter of Hydraulic Hoses and Tubes" desc="Size Matters: Calculating the Diameter of Hydraulic Hoses and Tubes In hydraulic systems, choosing the correct inner diameter is essential." /></Col>
            <Col sm={12} md={6} lg={4} data-aos="fade-up"><ImageCard image={imgOperatorProtection} learnMoreLink={'/goethe-event'} title="What you should know about hydraulic oils" desc="What You Should Know About Hydraulic Oils Hydraulic oils are an underrated component in plumbing systems. Many people simply." /></Col>
          </Row>
        </Container>
      </div> */}

      {/* <div>
        <SectionHeader
          title={"HANSA-FLEX Hydraulics Brazil"} /><br />
        <NumberGrid numbers={numbers} subtitles={subtitles} /><br /><br />
      </div> */}

      {/* <br /><br /><br /> */}

      {/* <div className="text-center div-gray">
        <SectionHeader
          title={"Check out our reviews on google!"}
          paragraph={"Curious about what others have to say about us? Take a moment to explore our Google reviews and discover why our customers rave about their experiences with us."} />
        <br />
        <Button variant="primary" href={googleReviewsLink} target="_blank" className="btn-google" style={{ boxShadow: '10px 10px 20px rgba(0, 0, 0, 0.2)' }}>{t("View our reviews on Google")}</Button>

        <br /><br /><br />
      </div> */}


      {/* <br /><br /><br /> */}

      <div>
        <SectionHeader title={"Industries served"} />
        <div className="home-imageContainer">
          {isMobile ? <>
            <img src={ingIndustries} alt="Description of the image" className='home-img' />
          </> : <>
            <img src={ingIndustries} alt="Description of the image" className='home-img' />
          </>}
        </div>

        {/* <br /><br /><br /><br /> */}

      </div>
      <div>
        {/* <SectionHeader
          title="News" />
        <Container className="custom-container">
          <Row>
            <Col sm={12} md={4} lg={4} data-aos="fade-up"><ImageCard image={imgLocal} learnMoreLink={'/Local'} title="Local or imported stock? What weighs most in the operation?" /></Col>
            <Col sm={12} md={4} lg={4} data-aos="fade-up"><ImageCard image={imgMeasurement} learnMoreLink={'/Measurement'} title="Essential Tools for Hydraulic Measurement" desc="" /></Col>
            <Col sm={12} md={4} lg={4} data-aos="fade-up"><ImageCard image={imgLessHeadache} learnMoreLink={'/LessHeadache'} title="Less Headache with Maintenance Plans" desc="" /></Col>
           

          </Row>
        </Container> */}
      </div>

      {/* <div>
        <Horizontal />
      </div> */}

    </div>

  );
}

export default HomePage;
